import Hub from 'base/hub'

// Using the HOST_NAME just for the pathname and search
// More info on URL(): https://developer.mozilla.org/en-US/docs/Web/API/URL/URL

const HOST_NAME = 'https://www.we-only-need-the-pathname.com'
const setEvents = ({ eventName, name, url, type, placement }) => {
  const newURL = new URL(url, HOST_NAME)

  const permalink = newURL?.pathname
  const searchParams = newURL?.search

  Hub.pub(eventName, {
    target_type: type,
    target_name: name,
    target_permalink: permalink,
    target_filtered_permalink: searchParams || null,
    target_placement: placement,
  })
}

export { setEvents as default }
